import { createContext } from "react";

const OnlineDriverTransactionScreen = createContext<any>(null);

export default OnlineDriverTransactionScreen;
